"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonIsDisabled = void 0;

var _core = require("@emotion/core");

var _feBrary = require("@domain-group/fe-brary");

var buttonIsDisabled = /*#__PURE__*/(0, _core.css)("background:", _feBrary.variables.colour.buttonDisabled, ";color:", _feBrary.variables.colour.buttonDisabledText, ";cursor:default;&:hover,&:focus{background:", _feBrary.variables.colour.buttonDisabled, ";color:", _feBrary.variables.colour.buttonDisabledText, ";}");
exports.buttonIsDisabled = buttonIsDisabled;